import React from "react";
import {inject, observer} from "mobx-react";
import styles from "./Screen.module.css"
import BandeauAerith from "./BandeauAerith";
import ScreenMode from "./ScreenMode";
import GamePadMode from "./GamePadMode";
import {withRouter} from "react-router-dom";
import ClientModeComponent from "./ClientModeComponent";
import {surveillerManettes} from "./detectionManette";

// Après le débranchement de la manette, l'écran revient au mode précédent au bout de ce délai
// (le temps de voir le résultat du test).
const DELAI_RETOUR_MS = 10000;

const ScreenClient = (inject("rootStore")(observer(class ScreenClient extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: "gamepad",
            logo: this.injected.rootStore.authStore.logo ?? "",
        }
    }

    // Une manette arrive : l'écran passe en mode test (une seule fois, au branchement) et retient le mode quitté.
    // Elle part : retour au mode précédent après un délai, sauf si la Caisse a changé de mode entre-temps.
    surManette(branchee) {
        window.clearTimeout(this.minuteurRetour);

        if (branchee) {
            if (this.state.mode !== "gamepad") {
                this.avantManette = {mode: this.state.mode, datas: this.state.datas};
                this.setState({mode: "gamepad"});
            }
        } else if (this.avantManette) {
            this.minuteurRetour = window.setTimeout(() => {
                const avant = this.avantManette;
                this.avantManette = null;
                if (avant && this.state.mode === "gamepad") {
                    this.setState({mode: avant.mode, datas: avant.datas});
                }
            }, DELAI_RETOUR_MS);
        }
    }

    async tryToConnect() {
        let url = window.location.hash.replace("#/screen/", "")
        let authResponse = await this.injected.rootStore.authStore.loginUrl(url);
        if (authResponse?.status === "success") {
            this.setState({
                logo: authResponse.logo
            })
        }
    }

    componentWillUnmount() {
        window.clearTimeout(this.minuteurRetour);
        if (this.arreterManettes) this.arreterManettes();
    }

    componentDidMount() {
        this.arreterManettes = surveillerManettes(branchee => this.surManette(branchee));
        this.tryToConnect()
        this.injected.rootStore.getEcho()
            .channel(`mode`)
            .listen('ModeScreenEvent', ev => {
                // Nouveaux réglages des mires (tableau de bord) : l'écran garde son mode actuel
                if (ev.type === "reglages") {
                    this.injected.rootStore.authStore.setReglagesManette(ev.data);
                    return;
                }

                // Nouveau fond du bandeau (choix manuel ou rotation réglée depuis le tableau de bord) : même principe
                if (ev.type === "fond") {
                    this.injected.rootStore.authStore.setReglagesFond(ev.data);
                    return;
                }

                // Un ordre de la Caisse prime : plus de retour automatique au mode précédent
                window.clearTimeout(this.minuteurRetour);
                this.avantManette = null;

                this.setState({
                    mode: ev.type,
                    datas: ev.data
                })

            })

        this.injected.rootStore.getEcho().connector.socket.on('connect', () => {
            this.injected.rootStore.authStore.isLoggedEcho = true;
        });

        this.injected.rootStore.getEcho().connector.socket.on('disconnect', () => {
            this.injected.rootStore.authStore.isLoggedEcho = false;
        });

    }


    get injected() {
        return this.props;
    }

    setMode() {
        if(this.state.mode === "publicité") {
            return  <ScreenMode/>
        }

        if(this.state.mode === "client") {
            return  <ClientModeComponent datas={this.state.datas}/>
        }

        if(this.state.mode === "gamepad") {
            const {stickZoneMorte, stickZoom} = this.injected.rootStore.authStore;
            return  <GamePadMode zoneMorte={stickZoneMorte} zoom={stickZoom}/>
        }
    }


    render() {
        return (
            <>

                <div className={"boardPec"}>
                    <BandeauAerith/>
                        {this.injected.rootStore.authStore.isLoggedDash ? (
                            this.setMode()) :
                            <div className={"container-fluid pt-5 min-vh-100 " + styles.backgroundMain}>
                                <div></div>
                            </div>

                        }
                </div>
            </>
        );
    }
})));

export default withRouter(ScreenClient);
